export default __webpack_public_path__ + "static/media/massupload.b6c2da69.svg";